import { looseToNumber } from '@develop/ia-utils'
import { color } from 'console-log-colors'
import type { PharmacyProductParams } from '@/models/middleware-types'
import { IaCookie } from '~/models/cookie'

/**
 * Ensures that the pharmacy data is fetched and loaded server-side
 * This ideally should be removed, and replaced by using useAsyncData and its cache (check how useProductDetails is implemented)
 * Currently it seems to fetch the pharmacy multiple times on each navigation (but may be 'accidentally' cached by graphql client)
 */
export default defineNuxtRouteMiddleware(async (to) => {
  onShowLogs(() => console.info(color.yellowBright('[GLOBAL] pharmacy\n'), to.path))

  const currentPharmacy = useCurrentPharmacyStore()

  const {
    pharmacyId: pharmacyIdSegment,
  } = to.params as Partial<PharmacyProductParams>

  const pharmacyIdParam = looseToNumber(pharmacyIdSegment)

  const pharmacyIdCookie = useCookie<string | undefined>(IaCookie.SelectedPharmacy)
  const pharmacyIdFromCookie = looseToNumber(pharmacyIdCookie.value)

  const pharmacyId = pharmacyIdParam ?? pharmacyIdFromCookie

  onShowLogs(() => console.log('pharmacy id', { url: pharmacyIdParam, cookie: pharmacyIdFromCookie }))

  // Set pharmacy state from cookie or url param
  if (pharmacyId) {
    onShowLogs(() => console.log('🏥 id:', pharmacyId))
    // Won't be needed when we use useAsyncData for pharmacy
    try {
      await currentPharmacy.ensure(pharmacyId)
      onShowLogs(() => console.log('✅ ensured pharmacy'))
    } catch (err) {
      onShowLogs(() => console.error('❌ error ensuring pharmacy', err))
    }
  }
})
